import { render, staticRenderFns } from "./AppGlobalSidebarListAccordion.vue?vue&type=template&id=72922103&"
import script from "./AppGlobalSidebarListAccordion.vue?vue&type=script&lang=js&"
export * from "./AppGlobalSidebarListAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports